import { Button, Modal, Popconfirm } from 'antd'
import RFQList from 'components/Purchasing/RFQ/List'
import PaymentButton from 'components/Sales/Enquiries/AddEnquiry/PaymentButton'
import RFQListByEnquiryLines from 'components/Sales/Enquiries/Lines/RFQList'
import { get } from 'lodash'
import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'
import { EnquiriesApi } from '../../../../api/Sales/Enquiries'
import UploadLinesCont from '../../../../components/Sales/Enquiries/AddEnquiry/UploadLinesCont'
import useModalShow from '../../../../elements/Hooks/useModalShow'
import useSubmit from '../../../../elements/Hooks/useSubmit'
import BoolFilter from '../../../../elements/Select/BoolFilter'
import BoolCell from '../../../../elements/Table/Cells/BoolCell'
import CustomTable from '../../../../elements/Table/CustomTable'
import { filterCheckedColumns } from '../../../../modules/Utils'

function List(props) {
  const { list, fetch, fetching, enquiry, onShow, isNew } = props
  const { visible, onShow: showModal, onCancel: hideModal } = useModalShow()

  const responseType = get(enquiry, 'responseType')
  const isSalesConfirmation = responseType === 'Sales Confirmation'
  const isProductQuote = responseType === 'Product Quotation'
  const isPhoneSales = responseType === 'Phone Sales'
  const isFullSKU = ['Sales Confirmation', 'Product Quotation', 'Phone Sales'].includes(responseType)
  //const isFullSKU = (responseType === 'Phone Sales') || (responseType === 'Sales Confirmation') || (responseType === 'Product Quotation')
  //console.log('responseType', responseType, 'isFullSKU:', isFullSKU)

  let columns = [
    {
      Header: 'ID',
      accessor: '_id',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'No',
      accessor: 'no',
      width: 100,
      Cell: ({ value, original }) => <a onClick={() => onShow(original, 'edit')}>{value || '_EMPTY_'}</a>,
    },
    {
      Header: 'Material No',
      accessor: 'materials.no',
      width: 150,
      hideable: true,
      hideDefault: false,
    },
    {
      Header: 'RFQ issued',
      accessor: 'rfq',
      width: 100,
      hideable: true,
      Cell: ({ value = [] }) => `${value.filter((i) => i?.issuance?.issued).length}/${value.length}`,
    },
    {
      Header: 'Product Code',
      accessor: 'product.code',
      width: 150,
      hideable: true,
      hideDefault: !isFullSKU,
    },
    { Header: 'Name', accessor: 'name' },
    { Header: 'QTY', accessor: 'unit', width: 100 },
    { Header: 'UOM', accessor: 'uom.code', width: 100 },
    {
      Header: 'Rate',
      accessor: 'rate',
      width: 100,
      hideable: true,
      hideDefault: !isFullSKU,
    },
    {
      Header: 'Tax Type',
      accessor: 'taxType' || 'tax.type',
      width: 100,
      hideable: true,
      hideDefault: !isFullSKU,
    },
    {
      Header: 'Tax %',
      accessor: 'tax.percentage',
      width: 100,
      hideable: true,
      hideDefault: !isFullSKU,
    },
    {
      Header: 'Tax Rate',
      accessor: 'tax.rate',
      width: 100,
      hideable: true,
      hideDefault: !isFullSKU,
    },
    {
      Header: 'To Ship',
      accessor: 'isShippable',
      filterMethod: filterCheckedColumns,
      Filter: BoolFilter,
      Cell: BoolCell,
      width: 100,
      hideable: true,
      hideDefault: !isFullSKU,
    },
    {
      Header: 'Description',
      accessor: 'description',
      width: 500,
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Category',
      accessor: 'category.name',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Group',
      accessor: 'group.name',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Product',
      accessor: 'product.name',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Reference',
      accessor: 'materials.reqNo',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Drawing No',
      accessor: 'materials.dwgNo',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'OEM Name',
      accessor: 'materials.oem.name',
      width: 150,
      hideable: true,
      hideDefault: isFullSKU,
    },
    {
      Header: 'OEM Part No',
      accessor: 'materials.oem.no',
      width: 150,
      hideable: true,
      hideDefault: isFullSKU,
    },
    {
      Header: 'OEM DWG',
      accessor: 'materials.oem.dwgNo',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Vendor No',
      accessor: 'materials.vendorNo',
      hideable: true,
      hideDefault: true,
    },
  ]


  const [submitting, submitFunc] = useSubmit(async () => {
    if (isProductQuote) {
      await EnquiriesApi.productQuoteWorkflow({ _id: enquiry._id })
      fetch()
    } else {
      await EnquiriesApi.autoWorkflow({ _id: enquiry._id })
      fetch()
    }
  })
  const isAllProductLines = list.every((i) => i.productLine) && list.length > 0 && isFullSKU

  const isPaid = enquiry.isPaid === true
  /*console.log(
    'pppp',
    isFullSKU,
    list.length,
    list.every((i) => i.productLine),
    list.map((i) => i.productLine)
  )*/
  return (
    <Fragment>
      <Modal
        visible={visible}
        title={'Upload Lines'}
        onCancel={hideModal}
        footer={null}
        destroyOnClose={true}
        width={'75%'}>
        <UploadLinesCont enquiry={enquiry} fetchLines={() => fetch()} hideModal={hideModal} />
      </Modal>
      <CustomTable
        data={list}
        isFilterable={true}
        fetching={fetching}
        fetch={fetch}
        CreateButton={() => (
          <div className="flex flex-row space-x-2">
            <Button type={'primary'} size="small" icon={'plus'} onClick={onShow} disabled={isNew}>
              New
            </Button>
            <Button
              style={{ marginLeft: 10 }}
              type="upload"
              size="small"
              icon={'plus'}
              onClick={showModal}
              disabled={isNew}>
              Upload
            </Button>
            {isAllProductLines && !isPhoneSales && (
              <Popconfirm
                title={'Are You sure'}
                onConfirm={submitFunc}
                okText="Create"
                cancelText="Cancel"
                disabled={isNew}>
                <Button
                  loading={submitting}
                  disabled={isNew || !['New Enquiry', 'New Lead'].includes(enquiry.status)}
                  size="small"
                  type="primary">
                  Auto WorkFlow
                </Button>
              </Popconfirm>
            )}
            {/*{isAllProductLines && !isPaid && isPhoneSales && (*/}
            <PaymentButton
              lines={list.map((i) => ({
                ...i,
                amount: ((get(i, 'rate') || 0) + (get(i, 'tax.rate') || 0)) * (get(i, 'unit') || 1),
                enquiry,
              }))}
              amountAccessor="amount"
            />
            {/*)}*/}
          </div>
        )}
        defaultSorted={[
          {
            id: 'no',
            desc: false,
          },
        ]}
        columns={columns}
        SubComponent={(row) => <RFQListByEnquiryLines id={row.original._key} />}
      />
    </Fragment>
  )
}

List.propTypes = {}
List.defaultProps = {}

export default List
